import * as React from 'react';
import RoutingNumberInput from './RoutingNumberInput';
import NumericInput from './NumericInput';
import LinkButton from './LinkButton';
import AuxiliaryCheckBox from './AuxiliaryCheckBox';
import '../css/addPayment.sass';
import { RulesMessages } from '../utils/validator';
import Formatter from './Formatter';
import PaymentIcon from './PaymentIcon';

export interface BankAccountDetails {
  bankCode: string;
  bankName: string;
  routingNumber: string;
  accountNumber: string;
  saveBank: boolean;
}

interface BankAccountProps {
  newBankAccountLabel?: string;
  accountNumberLabel?: string;
  clearLabel?: string;
  addBankLink?: string;
  rulesMessages?: { [key: string]: RulesMessages };
  displayDetails?: boolean;
  hideSavePaymentInfo?: boolean;
  onBrandIdentified?: Function;
  onLast4Identified?: Function;
  onAddBank: (details: BankAccountDetails) => void;
  languageCode?: string;
  rNumLabel?: string;
}

export default function NewBankAccount(props: BankAccountProps) {
  const {
    hideSavePaymentInfo = false,
    newBankAccountLabel = 'New Bank Account',
    accountNumberLabel = 'Account Number',
    clearLabel = 'Save for later use',
    addBankLink = 'Add Bank Account'
  } = props;
  const [state, setState] = React.useState<BankAccountDetails>({
    bankCode: 'NEWBANK',
    bankName: 'New Bank',
    routingNumber: '',
    accountNumber: '',
    saveBank: true
  });

  return (
    <div className="addPayment">
      {props.displayDetails && (
        <>
          <div>{newBankAccountLabel}</div>
          <div className="endingWith">
            <PaymentIcon
              className="bankImg"
              brandName={state.bankName}
              brand={state.bankCode}
            />
            {!!state.accountNumber && (
              <span className="bankDetails">
                {' '}
                <Formatter value={state.accountNumber} type="bankaccount" />
              </span>
            )}
          </div>
          <div className="hr">&nbsp;</div>
        </>
      )}
      <div>
        <RoutingNumberInput
          name="routingNumber"
          id="routingNumber"
          languageCode={props.languageCode}
          rulesMessages={
            props.rulesMessages && props.rulesMessages.routingNumber
          }
          hasError={false}
          label={props.rNumLabel}
          onError={() => {
            setState({ ...state, routingNumber: '' });
          }}
          onComplete={(routingNumber?: string) => {
            if (routingNumber) {
              setState({ ...state, routingNumber });
            } else {
              setState({ ...state, routingNumber: '' });
            }
          }}
          onChange={(e: any) => {
            if (
              e.target.bank &&
              e.target.bank.code &&
              e.target.bank.code.toUpperCase() !== 'NEWBANK'
            ) {
              if (props.onBrandIdentified !== undefined) {
                props.onBrandIdentified({
                  bankCode: e.target.bank.code,
                  bankName: e.target.bank.name
                });
              }
              setState({
                ...state,
                bankCode: e.target.bank.code.toUpperCase(),
                bankName: e.target.bank.name
              });
            } else {
              setState({
                ...state,
                bankCode: 'NEWBANK',
                bankName: 'New Bank'
              });
              if (props.onBrandIdentified !== undefined) {
                props.onBrandIdentified({
                  bankCode: 'NEWBANK',
                  bankName: 'New Bank'
                });
              }
            }
          }}
          required
        />
      </div>
      <div>
        <NumericInput
          name="accountNumber"
          id="accountNumber"
          value={state.accountNumber}
          hasError={false}
          label={accountNumberLabel}
          maxLength={17}
          rulesMessages={
            props.rulesMessages && props.rulesMessages.accountNumber
          }
          minLength={6}
          useRulesMessagesProp={props.languageCode!="es"}
          onError={() => {
            setState({ ...state, accountNumber: '' });
          }}
          onComplete={(accountNumber?: string) => {
            if (accountNumber) {
              if (props.onLast4Identified) {
                props.onLast4Identified(
                  accountNumber.slice(accountNumber.length - 4)
                );
              }
              setState({ ...state, accountNumber });
            } else {
              setState({ ...state, accountNumber: '' });
            }
          }}
          required
        />
      </div>
      {!hideSavePaymentInfo && (
        <div>
          <AuxiliaryCheckBox
            name="saveBank"
            label={clearLabel}
            id="saveBank"
            checked={state.saveBank}
            hasError={false}
            onComplete={(event: any) =>
              setState({
                ...state,
                saveBank: event.target.checked
              })
            }
            onChange={(event: any) =>
              setState({
                ...state,
                saveBank: event.target.checked
              })
            }
          />
        </div>
      )}
      <div style={{ textAlign: 'right' }}>
        <LinkButton
          name="addBankAcc"
          id="addBankAcc"
          smol
          disabled={!(!!state.accountNumber && !!state.routingNumber)}
          onClick={() => {
            props.onAddBank(state);
          }}
        >
          {addBankLink}
        </LinkButton>
      </div>
    </div>
  );
}
